import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FC1C62DB-A06D-48F8-962F-F60FE41E4F65
 * name swap-vertical-variant
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-vertical-variant.svg
 * tags
 * - Arrow 
 */
export const SwapVerticalVariantIcon = createSvgIcon(<><path d="M18,4L14,8H17V16A2,2 0 0,1 15,18A2,2 0 0,1 13,16V8A4,4 0 0,0 9,4A4,4 0 0,0 5,8V16H2L6,20L10,16H7V8A2,2 0 0,1 9,6A2,2 0 0,1 11,8V16A4,4 0 0,0 15,20A4,4 0 0,0 19,16V8H22L18,4Z" /></>, 'SwapVerticalVariantIcon');
export default SwapVerticalVariantIcon